import { render, staticRenderFns } from "./LinksCategoria.vue?vue&type=template&id=13f47705"
import script from "./LinksCategoria.vue?vue&type=script&lang=js"
export * from "./LinksCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports